import styled from 'styled-components'

const Link = styled.a.attrs({ target: '_blank', rel: 'noopener noreferrer' })`
  color: inherit;
  cursor: ${({ href }) => (href ? 'pointer' : 'default')};
  text-decoration: none;
`

export default Link
